import { useEffect, useMemo, useState } from "react";
import { useSession } from "@clerk/clerk-react";
import { getMyMeetsPast as getMyMeetsPastApi } from "@/api/meets";
import PastMeetsCard from "../cards/past-meets-card";
import { CalendarCheck } from "lucide-react";
import {Input} from "@heroui/input";
import { formatDate } from "@/utils/dates";
import PulledDownWrapper from "../wrappers/pulled-down-wrapper";
import { Search } from "lucide-react";

const PastMeetsComp = () => {
const { session } = useSession();
const [records, setRecord] = useState([]);
const [filteredRecords, setFilteredRecords] = useState([])
const [searchText, setSearchText] = useState('')

useEffect(() => {
    getMyMeetsPast();
}, []);

useEffect(() => {
    if (!records) return;

    const filtered = records.filter((rec) => {
        const text = searchText.toLowerCase();
        return (
        rec.title?.toLowerCase().includes(text) ||
        rec.description?.toLowerCase().includes(text)
        );
    });

    setFilteredRecords(filtered);
}, [records, searchText]);

async function getMyMeetsPast() {
    const token = await session.getToken();
    getMyMeetsPastApi(token).then((_resp) => {
        if (_resp.data.Result === "OK") {
            const records = _resp.data.Records
            setRecord(records);
            setFilteredRecords(records)
        }
    }).catch((_resp) => {
        console.error(_resp);
    }).finally(() => {});
}

const groups = useMemo(() => {
    const map = new Map();
    for (const rec of filteredRecords) {
        const pretty = formatDate(rec.meeting_date);
        if (!map.has(pretty)) {
        map.set(pretty, { key: rec.meeting_date, pretty, items: [] });
        }
        map.get(pretty).items.push(rec);
    }
    return Array.from(map.values());
}, [filteredRecords]);

return (
<>
{records.length > 0?
    <div className="ms-4 me-4 gap-2">
        <div className="fixed top-[75px] left-0 right-0 z-[50] px-4">
            <Input radius="full" variant="bordered"
            onChange={(e) => setSearchText(e.target.value)} value={searchText} placeholder="Search..."  startContent={<Search size={17} />} 
            className="w-full bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm rounded-full shadow-lg"/>
        </div>
    </div>
: null}
<PulledDownWrapper onRefresh={getMyMeetsPast}>
    <div className="max-w-[900px] grid grid-cols-12 gap-2">
        {groups.length > 0 ? (
            groups.map((group, gi) => (
                <div key={group.key} className={`contents`}>
                    <div className={`col-span-12 ${gi === 0? 'mt-10': ''}`}>
                        <div className="text-center py-4 opacity-60">
                            {group.pretty}
                        </div>
                    </div>

                    {group.items.map((rec, ri) => {
                        const isLastGroup = gi === groups.length - 1;
                        const isLastCard = ri === group.items.length - 1;
                        const mb = isLastGroup && isLastCard ? "mb-20" : "mb-2";
                        return (
                            <div key={rec._id} className={`col-span-12 flex flex-col ${mb}`}>
                                <PastMeetsCard _record={rec} _onResp={null} />
                            </div>
                        );
                    })}
                </div>
            ))
        ) : (
            <div className="col-span-12 flex flex-col items-center justify-center py-12 text-center text-zinc-400">
                <CalendarCheck className="w-12 h-12 mb-2 opacity-50" />
                <h2 className="text-lg font-medium">No Past Meetings</h2>
                <p className="text-sm text-zinc-500">Don't worry, they'll come 😌</p>
            </div>
        )}
    </div>
</PulledDownWrapper>
</>
);
};

export default PastMeetsComp;